import { mapPriliminarys, mapSowSections, Priliminary, SowSection } from "./tenderSow";

export interface ProjectTenderDetailInterface {
    project_tender_part_id: number;
    folder_id: number;
    title: string;
    company_name?: string;
    project_address: string;
    coverPageDesc: string;
    tender_list: TenderListInterface[];
    tender_document: TenderDocumentInterface[];
    have_cover_page_data: boolean;
    have_content_data: boolean;
    have_priliminiery_data: boolean;
    share_contact: TenderShareContact[];
}

export const mapProjectTenderDetail = (data:any): ProjectTenderDetailInterface => {
    if(!data){
        throw new Error('Invalied ProjectTenderDetail type')
    }
    const ProjectTenderDetails: ProjectTenderDetailInterface = {
        project_tender_part_id: data.project_tender_part_id,
        folder_id: data.folder_id,
        title: data.title,
        company_name: data.company_name || '',
        project_address: data.project_address,
        coverPageDesc: data.tender?.text || '', 
        tender_list: mapTenderLists(data.tender_list),
        tender_document: mapTenderDocuments(data.tender_document),
        have_cover_page_data: data.have_cover_page_data,
        have_content_data: data.have_content_data,
        have_priliminiery_data: data.have_priliminiery_data,
        share_contact: mapTenderShareContacts(data.share_contact),
       
    }

    return ProjectTenderDetails;

}

export const mapProjectTenderDetails = (data: any[]): ProjectTenderDetailInterface[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid ProjectTenderDetails data');
    }
  
    return data.map(mapProjectTenderDetail);
};

//========================================================== share_contact

export interface TenderShareContact {
    tender_part_share_id: number;
    project_tender_part_id: number;
    can_view: number;
    can_edit: number;
    by: string;
    id: number;
    company_name: string|null;
    first_name: string;
    last_name: string;
    profile_image: string;
    login_user_id: number|null;
}

export const mapTenderShareContact = (data:any): TenderShareContact => {
    if(!data){
        throw new Error('Invalied TenderShareContact type')
    }
    const TenderShareContacts: TenderShareContact = {
        tender_part_share_id: data.tender_part_share_id,
        project_tender_part_id: data.project_tender_part_id,
        company_name: data.company_name,
        can_view: data.can_view,
        can_edit: data.can_edit,
        by: data.by,
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        profile_image: data.profile_image,
        login_user_id: data.login_user_id,
       
       
    }

    return TenderShareContacts;

}

export const mapTenderShareContacts = (data: any[]): TenderShareContact[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid TenderShareContacts data');
    }
  
    return data.map(mapTenderShareContact);
};


//========================================================== tender_document

export interface TenderDocumentInterface {
    id: number;
    project_tender_part_id: number;
    document_name: string;
    document: string;
    updated_at: string;
}

export const mapTenderDocument = (data:any): TenderDocumentInterface => {
    if(!data){
        throw new Error('Invalied TenderDocument type')
    }
    const TenderDocuments: TenderDocumentInterface = {
        id: data.id,
        project_tender_part_id: data.project_tender_part_id,
        document_name: data.document_name,
        document: data.document,
        updated_at: data.updated_at,
       
    }

    return TenderDocuments;

}

export const mapTenderDocuments = (data: any[]): TenderDocumentInterface[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid TenderDocuments data');
    }
  
    return data.map(mapTenderDocument);
};

//========================================================== tender_list

export interface TenderListInterface {
    tender_part_share_id: number;
    fixed_tender_list: number;
    first_name: string;
    last_name: string;
    company_name: string;
    profile_image: string;
    by: string;
    cover_page: string;
    section_data: SowSection[];
    priliminiery_data: Priliminary[];
    isCheckedComparePrice: boolean;
}

export const mapTenderList = (data:any): TenderListInterface => {
    if(!data){
        throw new Error('Invalied TenderList type')
    }
    const TenderLists: TenderListInterface = {
        tender_part_share_id: data.tender_part_share_id,
        fixed_tender_list: data.fixed_tender_list,
        first_name: data.first_name,
        last_name: data.last_name,
        company_name: data.company_name,
        profile_image: data.profile_image,
        by: data.by,
        cover_page: data.cover_page?.text || '', 
        section_data: mapSowSections(data.section_data),
        priliminiery_data: mapPriliminarys(data.priliminiery_data),
        isCheckedComparePrice: false,
       
    }

    return TenderLists;

}

export const mapTenderLists = (data: any[]): TenderListInterface[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid TenderLists data');
    }
  
    return data.map(mapTenderList);
};
